import { GridCallout } from 'components/grid_callout'
import { MLPSection } from '../MLPSection'
import { css, cx, useTheme } from '@fable/theme'
import { MLPBookCalloutText } from './MLPBookCalloutText'
import { MLPBookCalloutImages } from './MLPBookCalloutImages'
import { GridCalloutCard } from 'components/grid_callout/types'
import { bookCards } from './calloutCards'

interface Props {
  className?: string
  gridClassName?: string
  cards?: GridCalloutCard[]
  reverse?: boolean
}

export const MLPBookCallout = ({
  cards = bookCards,
  className,
  gridClassName,
  reverse = false,
}: Props) => {
  const { colors } = useTheme()

  return (
    <MLPSection id="ebooks" className={className}>
      <GridCallout
        className={cx(
          css`
            .fds--grid-callout-card__title {
              max-width: 200px;
            }
          `,
          gridClassName
        )}
        textContent={<MLPBookCalloutText />}
        imageContent={<MLPBookCalloutImages />}
        cards={cards}
        theme={{ light: colors.uiBlueUltraLight, dark: colors.uiBlueLight }}
        reverse={reverse}
      />
    </MLPSection>
  )
}
